import {useEffect, useState} from 'react';
import {UseFormMethods, useWatch} from 'react-hook-form';
import {
  HelpCenterArticle,
  HelpCenterPageCommonProps,
} from '../../../../pages/HelpCenter/types';
import {Locale} from '../../../../types';
import {FormDataRaw} from '../types';

const MAX_ARTICLE_RESULTS = 5;

interface TopAnswerArgs {
  control: UseFormMethods['control'];
  endpoints: HelpCenterPageCommonProps['endpoints'];
  locale: Locale;
}

export const useTopAnswers = ({control, endpoints, locale}: TopAnswerArgs) => {
  const [articles, setArticles] = useState<HelpCenterArticle[] | null>(null);

  const subject = useWatch<FormDataRaw['subject']>({
    control,
    defaultValue: null,
    name: 'subject',
  });

  useEffect(() => {
    if (subject?.value.id) {
      endpoints
        .loadArticles({
          locale,
          sectionId: subject.value.id,
          per_page: 5,
          page: 1,
        })
        .then(result => {
          setArticles(result.articles.slice(0, MAX_ARTICLE_RESULTS));
        });
    }
  }, [endpoints, subject?.value.id, locale]);

  return articles;
};
